export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "asrWorker.e8a33a5d81991adf8e00.js");
}
